// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__G4c_s","detailsBorder":"styles_detailsBorder__1NS81"};